export default __webpack_public_path__ + "static/media/stackoverflow.00e3115a.webp";